import axios from '../../config/axios';
import API_ENDPOINTS from '../../config/api';

// Function to fetch latest SAP intake data for a specific project
export const fetchLatestSAPIntakeData = async (projectId) => {
  try {
    const response = await axios.get(API_ENDPOINTS.sapIntake.latest, { params: { projectId } });
    if (!response.data || !response.data.success) {
      return null;
    }
    return response.data.data;
  } catch (error) {
    console.error('Error fetching SAP intake data:', error.response?.data || error.message);
    return null;
  }
};

export const autoPopulateSapFromProtocol = async (projectId) => {
  const response = await axios.post(API_ENDPOINTS.sapIntake.autoPopulateFromProtocol, { projectId });
  return response.data;
};

// Function to format SAP intake data for LLM context
export const formatSAPIntakeForContext = (data) => {
  if (!data) return '';
  return Object.entries(data)
    .filter(([key, value]) => value !== '' && value !== null && value !== undefined)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return `${key}: ${value.join(', ')}`;
      } else if (typeof value === 'object') {
        return `${key}: ${JSON.stringify(value)}`;
      } else {
        return `${key}: ${value}`;
      }
    })
    .join('\n');
};

// Function to get latest SAP intake data and format it for LLM
export const getLatestSAPIntakeContext = async (projectId) => {
  try {
    const latestData = await fetchLatestSAPIntakeData(projectId);
    return formatSAPIntakeForContext(latestData);
  } catch (error) {
    console.error('Error getting SAP intake context:', error);
    return '';
  }
};

export default {
  fetchLatestSAPIntakeData,
  formatSAPIntakeForContext,
  getLatestSAPIntakeContext,
  autoPopulateSapFromProtocol
}; 